import { createContext, useContext } from 'react';
export const ProductDataContext = /*#__PURE__*/createContext({
  product: undefined,
  associatedBundles: undefined
});
export const useProductData = () => {
  return useContext(ProductDataContext);
};